import('immer').then(mod => {
  let { enableES5 } = mod;
  enableES5();

  import('./app').then(() => {
    console.log('load app successfully');
  }).catch(err => console.error(err));
}).catch(err => console.log(err));